import ProductBox from '../../blocks/svg-elements/product-box/ProductBox.vue';
import { BundleIcon } from '../../blocks/svg-elements/bundle-icon';
import { Tooltip } from '../../blocks/output-elements/tooltip';
import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
import { ThreeDots } from '../../blocks/svg-elements/three-dots';
import { CheckmarkIcon } from '../../blocks/svg-elements/checkmark-icon';
import DateHelper from '../../myAccount/helper/date-helper';
import AdditionalDetails from './../shared/additional-details.vue';
import EditCartItemHelper from './../helper/edit-cart-item-helper';
import NumberFormatterHelper from '../../myAccount/helper/numberFormat-helper';
import QuantityHelper from '@/dow-platform/components/commerce/myAccount/helper/quantity-helper';
import i18nHelper from '../../myAccount/helper/i18n-helper';
const updateTimeoutDuration = 1000;
export default {
  name: 'CartItem',
  props: ['itemData', 'isMultiPo', 'isUnconfiguredEntry', 'isNeedRemoveEntry', 'isNeedEditEntry', 'isCheckoutPage', 'shipToCountry'],
  components: {
    ProductBox,
    Tooltip,
    ChevronIcon,
    AdditionalDetails,
    BundleIcon,
    ThreeDots,
    CheckmarkIcon
  },
  created() {
    window.updateTimeout = null;
  },
  data() {
    return {
      showDetails: this.isNeedRemoveEntry || this.isNeedEditEntry || this.isCheckoutPage,
      moveEditRemove: this.isUnconfiguredEntry || this.isNeedRemoveEntry || this.isNeedEditEntry,
      originalPONumber: this.itemData.lineItemPO
    };
  },
  watch: {
    itemData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.showDetails = this.isNeedRemoveEntry || this.isNeedEditEntry || this.isCheckoutPage;
          this.moveEditRemove = this.isUnconfiguredEntry || this.isNeedRemoveEntry || this.isNeedEditEntry;
          this.originalPONumber = this.itemData.lineItemPO;
        }
      }
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    },
    geti18nDisplayValue: function (key) {
      return i18nHelper.geti18nDisplayValue(key);
    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    emitRemoveItemModal(itemData) {
      this.$emit('show-remove-item-modal', {
        itemData,
        showModal: true
      });
    },
    editItem() {
      let cartItemInfo = {
        itemNo: this.itemData.sapLineItemNumber,
        isMarketOffer: this.itemData.isMarketOffer ?? false,
        isMultiPO: this.isMultiPo ?? false,
        forwardingAgent: this.itemData.forwardingAgent ?? '',
        materialNumber: this.itemData.materialNumber
      };
      EditCartItemHelper.editCartItem(cartItemInfo);
    },
    showQuantityTooltip() {
      return this.itemData.salesUnitSapName && this.itemData.priceUnitSapName && this.itemData.salesUnitSapName !== this.itemData.priceUnitSapName;
    },
    quantityTooltipText() {
      const convertedQuantity = this.itemData.convertedQuantity;
      const priceUnit = this.itemData.priceUnitSapName;
      return QuantityHelper.getFormattedQuantity(convertedQuantity, priceUnit);
    },
    getFormattedQuantity: function (value, unit) {
      return QuantityHelper.getFormattedQuantity(value, unit);
    },
    getFormattedDate: function (formattedDate) {
      let date = Date.parse(formattedDate);
      const dateObj = new Date(date);
      if (Number.isNaN(dateObj.getTime())) {
        return '';
      }
      const day = dateObj.toLocaleDateString(store.state.browser.cookies['languageCode'] || 'en-us', {
        day: '2-digit'
      });
      const month = dateObj.toLocaleDateString(store.state.browser.cookies['languageCode'] || 'en-us', {
        month: 'short'
      });
      const year = dateObj.toLocaleDateString(store.state.browser.cookies['languageCode'] || 'en-us', {
        year: 'numeric'
      });
      return `${day} ${DateHelper.capitalizeMonth(month)} ${year}`;
    },
    getFormattedNumber: function (value) {
      return NumberFormatterHelper.getFormattedNumber(value);
    },
    updateItemPO(cartItem) {
      cartItem.poNumber = cartItem.poNumber?.trim();
      let hasPONumberChanged = this.originalPONumber != cartItem.poNumber;
      cartItem.isPoInvalid = cartItem.poNumber.length > 35;
      if (hasPONumberChanged && !cartItem.isPoInvalid) {
        this.clearUpdateTimeout();
        this.$store.commit('cart/updateLineItemNumbersToSave', {
          "hasPurchaseOrderNumberUpdated": false,
          "purchaseOrderNumberValue": cartItem.poNumber,
          "sapLineItemNumbers": [this.itemData.sapLineItemNumber]
        });
        window.updateTimeout = window.setTimeout(() => {
          let self = this;
          this.$emit("saveFailure", false);
          this.$store.dispatch('cart/updatePONumber').then(data => {
            self.originalPONumber = cartItem.poNumber; // update to new value
            self.$emit("cartDataUpdated", data);
          }).catch(error => {
            console.log("Error", error);
            this.$emit("saveFailure", true);
          });
        }, updateTimeoutDuration);
      }
    },
    clearUpdateTimeout() {
      window.clearTimeout(window.updateTimeout);
    },
    ltlSurchargeLabel(item) {
      return !this.isCheckoutPage && item.displayPrice ? this.getI18nMessage('cart.page.line.item.unitPrice.surcharge') : '';
    },
    getUnitPrice(item) {
      if (this.isCheckoutPage) {
        return item.formatUnitPrice;
      }
      return item.displayPrice && item.formattedDisplayPrice ? item.formattedDisplayPrice : item.formatUnitPrice;
    },
    getTotalPrice(item) {
      if (this.isCheckoutPage) {
        return item.checkoutTotalPrice?.formattedValue;
      }
      return item.totalPrice?.formattedValue;
    }
  }
};